var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        setJ1: _vm.setJ1,
        getJ1: _vm.getJ1,
        setJ2: _vm.setJ2,
        getJ2: _vm.getJ2,
        setA: _vm.setA,
        getA: _vm.getA,
        setP: _vm.setP,
        getP: _vm.getP,
        setT: _vm.setT,
        getT: _vm.getT,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        setJ1,\n        getJ1,\n        setJ2,\n        getJ2,\n        setA,\n        getA,\n        setP,\n        getP,\n        setT,\n        getT,\n      }"}],attrs:{"id":"screan"}},[_c('img',{attrs:{"src":require("../assets/img/light/screan.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        setJ1: _vm.setJ1,
        getJ1: _vm.getJ1,
        setJ2: _vm.setJ2,
        getJ2: _vm.getJ2,
        setA: _vm.setA,
        getA: _vm.getA,
        setP: _vm.setP,
        getP: _vm.getP,
        setT: _vm.setT,
        getT: _vm.getT,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        setJ1,\n        getJ1,\n        setJ2,\n        getJ2,\n        setA,\n        getA,\n        setP,\n        getP,\n        setT,\n        getT,\n      }"}],attrs:{"id":"tou"}},[_c('img',{attrs:{"src":require("../assets/img/tou1.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        setJ1: _vm.setJ1,
        getJ1: _vm.getJ1,
        setJ2: _vm.setJ2,
        getJ2: _vm.getJ2,
        setA: _vm.setA,
        getA: _vm.getA,
        setP: _vm.setP,
        getP: _vm.getP,
        setT: _vm.setT,
        getT: _vm.getT,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        setJ1,\n        getJ1,\n        setJ2,\n        getJ2,\n        setA,\n        getA,\n        setP,\n        getP,\n        setT,\n        getT,\n      }"}],attrs:{"id":"ai"}},[_c('img',{attrs:{"src":require("../assets/img/ai.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        setJ1: _vm.setJ1,
        getJ1: _vm.getJ1,
        setJ2: _vm.setJ2,
        getJ2: _vm.getJ2,
        setA: _vm.setA,
        getA: _vm.getA,
        setP: _vm.setP,
        getP: _vm.getP,
        setT: _vm.setT,
        getT: _vm.getT,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        setJ1,\n        getJ1,\n        setJ2,\n        getJ2,\n        setA,\n        getA,\n        setP,\n        getP,\n        setT,\n        getT,\n      }"}],attrs:{"id":"jjj1"}},[_c('img',{attrs:{"src":require("../assets/img/shop/j21.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        setJ1: _vm.setJ1,
        getJ1: _vm.getJ1,
        setJ2: _vm.setJ2,
        getJ2: _vm.getJ2,
        setA: _vm.setA,
        getA: _vm.getA,
        setP: _vm.setP,
        getP: _vm.getP,
        setT: _vm.setT,
        getT: _vm.getT,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        setJ1,\n        getJ1,\n        setJ2,\n        getJ2,\n        setA,\n        getA,\n        setP,\n        getP,\n        setT,\n        getT,\n      }"}],attrs:{"id":"jjj2"}},[_c('img',{attrs:{"src":require("../assets/img/shop/j22.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        setJ1: _vm.setJ1,
        getJ1: _vm.getJ1,
        setJ2: _vm.setJ2,
        getJ2: _vm.getJ2,
        setA: _vm.setA,
        getA: _vm.getA,
        setP: _vm.setP,
        getP: _vm.getP,
        setT: _vm.setT,
        getT: _vm.getT,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        setJ1,\n        getJ1,\n        setJ2,\n        getJ2,\n        setA,\n        getA,\n        setP,\n        getP,\n        setT,\n        getT,\n      }"}],attrs:{"id":"police"}},[_c('img',{attrs:{"src":require("../assets/img/shop/j1.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/shop/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdd0d92a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop.vue
// module id = null
// module chunks = 